import React from 'react'
import {Navigate} from 'react-router-dom'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'

function ComparaisonMenu() {
  
  return (
    <div>
        <EnteteMildiou titre={'Comparaison'}/>
        <FooterNavMildiou/>
        <div className='containerMildiou'> 
            <div className='titrePlus row'>En cours de construction</div>
        </div>
    </div>
  )
}

export default ComparaisonMenu